// Module
var code = "<div class=\"markdown-view container\" ng-bind-html=\"html\">\n</div>";
// Exports
module.exports = code;